/* eslint-disable */
import Vue from 'vue'
import Moment from 'moment';

const locale = localStorage.getItem("locale");
if(locale == null){
    Moment.locale("pt-br");    
} 
else{
    switch(localStorage.getItem("locale")){
        case process.env.VUE_APP_DB_LOCALE_ES:
            Moment.locale("es");    
            break;
            
        case process.env.VUE_APP_DB_LOCALE_EN:
            Moment.locale("us");    
            break;

        default:
            Moment.locale("pt-br");    
            break;                        
    }
}

Vue.prototype.$moment = Moment;